import { Routes, Route, HashRouter } from "react-router-dom";
import { connect } from "react-redux";
import { isEmpty, isEqual, max, omit } from "lodash";
import { selectRoutes, doLoad } from "controllers/common/action";
import React, { Suspense } from "react";
import { constructPath } from "routes";
import { PreserveScroll } from "components";
import { Intent, Spinner } from "@blueprintjs/core";

let current = [];

const printRoute = (route) => {
  if (route) {
    const path = constructPath(route);
    if (!isEmpty(path)) {
      current.push([`(${route.data?.id})`, `[${route.data?.name}]`, `${path}`]);
    }
    route.children?.forEach((c) => printRoute(c));
  }
};

const printRoutes = (route) => {
  const prev = Array.from(current);
  current = [["id", "name", "path"]];
  printRoute(route);
  const [m0, m1] = [max(current.map((c) => c[0].length)), max(current.map((c) => c[1].length))];
  current = current.map(
    (c, i) =>
      `${"\xa0".repeat(3 - `${i}`.length)}${c[0]}${"\xa0".repeat(m0 - c[0].length + 1)}${c[1]}${"\xa0".repeat(
        m1 - c[1].length + 1
      )}${c[2]}`
  );
  if (!isEqual(prev, route)) {
    // keep this logging statement as it only prints for development
    console.log({ routes: current });
  }
};

const renderRoute = (route) => {
  const { data } = route;
  if (data) {
    const { buildProps } = data;
    const Element = data.element;
    const props = buildProps?.() || {};
    return (
      <Route
        key={data.name}
        {...(data.path === "/" ? { index: true } : { path: data.path ? data.path : "/" })}
        element={<Element node={route} page={omit(data, ["element"])} {...props} />}
        children={isEmpty(route.children) ? undefined : route.children.map((child) => renderRoute(child))}
      />
    );
  }
};

class Routing extends React.Component {
  componentDidMount() {
    this.props.doLoad();
  }

  render() {
    const { routes } = this.props;
    if (process.env.NODE_ENV === "development") {
      printRoutes(routes?.root);
    }
    return (
      <HashRouter>
        <PreserveScroll />
        <Suspense
          fallback={
            <div className="global-loading">
              <Spinner intent={Intent.PRIMARY} />
            </div>
          }
        >
          <Routes>{routes?.root.children.map((child) => renderRoute(child))}</Routes>
        </Suspense>
      </HashRouter>
    );
  }
}

const mapStateToProps = (state) => ({
  routes: selectRoutes(state),
});

const mapActionToProps = {
  doLoad,
};

export default connect(mapStateToProps, mapActionToProps)(Routing);
